import script from "./UserSettingsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserSettingsView.vue?vue&type=script&setup=true&lang=ts"

import "./UserSettingsView.vue?vue&type=style&index=0&id=ff59d366&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff59d366"]])

export default __exports__